// extracted by mini-css-extract-plugin
export default {"genericCard":"Om-z","inline":"Pm-z","mastercard":"Qm-z","discover":"Rm-z","visa":"Sm-z","amex":"Tm-z","active":"Um-z"};